import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { digerOturumlariKapat, oturumlar, type OturumOzeti } from '../api/kimlik';
import { Dugme, HataKutusu } from '../bilesenler/temel';
import { zamanMetni } from '../bicim/tarih';

/**
 * CİHAZLARIM.
 *
 * Şüpheli erişimi personelin KENDİSİNİN fark edebilmesi için. Tanımadığı bir
 * cihaz görürse diğerlerini kapatabilir; bu oturum ayakta kalır.
 */
export function Cihazlarim() {
  const kuyruk = useQueryClient();

  const liste = useQuery({ queryKey: ['oturumlar'], queryFn: oturumlar });

  const kapat = useMutation({
    mutationFn: digerOturumlariKapat,
    onSuccess: () => kuyruk.invalidateQueries({ queryKey: ['oturumlar'] }),
  });

  const digerVarMi = (liste.data ?? []).some((o) => !o.buCihazMi);

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h1 className="text-lg font-semibold text-slate-900">Cihazlarım</h1>
          <p className="mt-1 text-sm text-slate-600">
            Hesabınızla açık olan oturumlar. Tanımadığınız bir cihaz görürseniz diğerlerini kapatın
            ve şifrenizi değiştirin.
          </p>
        </div>

        <Dugme
          tur="tehlike"
          tikla={() => kapat.mutate()}
          bekliyor={kapat.isPending}
          pasif={!digerVarMi}
          cocuk="Diğerlerini kapat"
        />
      </div>

      <HataKutusu hata={liste.error ?? kapat.error} />

      {liste.isPending && <p className="text-sm text-slate-500">Yükleniyor…</p>}

      <ul className="divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white">
        {(liste.data ?? []).map((oturum) => (
          <OturumSatiri key={oturum.oturumId} oturum={oturum} />
        ))}
      </ul>
    </div>
  );
}

function OturumSatiri({ oturum }: { oturum: OturumOzeti }) {
  return (
    <li className="flex flex-wrap items-center justify-between gap-3 p-4">
      <div className="min-w-0">
        <p className="flex items-center gap-2 text-sm font-medium text-slate-900">
          {oturum.istemci === 'panel'
            ? 'Yönetim paneli'
            : oturum.istemci === 'pwa'
              ? 'Personel uygulaması'
              : 'Bilinmiyor'}
          {oturum.buCihazMi && (
            <span className="rounded bg-kurum-100 px-1.5 py-0.5 text-xs font-normal text-kurum-700">
              bu cihaz
            </span>
          )}
        </p>
        <p className="mt-0.5 truncate text-xs text-slate-500">
          {oturum.cihazBilgisi ?? 'Cihaz bilgisi yok'}
        </p>
      </div>

      <div className="text-right text-xs text-slate-500">
        <p>Giriş: {zamanMetni(oturum.olusturmaZamani)}</p>
        <p>Son kullanım: {zamanMetni(oturum.sonKullanimZamani)}</p>
        <p>{oturum.ipAdresi ?? '—'}</p>
      </div>
    </li>
  );
}
